import http from 'plugins/axios';

export default {
  types() {
    return http.get({ url: '/ta/admin/tenant/public-subject/bill-statistic/types' });
  },
  page({ startTime = '', endTime = '', coin = '', page = 1, size = 20 } = {}) {
    let url = `/ta/admin/tenant/public-subject/bill-statistic/page?page=${page}&size=${size}`;
    if (startTime) url += `&startTime=${startTime}`;
    if (endTime) url += `&endTime=${endTime}`;
    if (coin) url += `&coin=${encodeURIComponent(coin)}`;
    return http.get({ url });
  },
  total({ startTime = '', endTime = '', coin = '' } = {}) {
    let url = '/ta/admin/tenant/public-subject/bill-statistic/total';
    const params = [];
    if (startTime) params.push(`startTime=${startTime}`);
    if (endTime) params.push(`endTime=${endTime}`);
    if (coin) params.push(`coin=${encodeURIComponent(coin)}`);
    if (params.length) url += `?${params.join('&')}`;
    return http.get({ url });
  },
  detail({
    statDate = '',
    startTime = '',
    endTime = '',
    billType = '',
    coin = '',
    counterpartyUserId = '',
    bizId = '',
    page = 1,
    size = 20,
  } = {}) {
    let url = `/ta/admin/tenant/public-subject/bill-statistic/detail?page=${page}&size=${size}&billType=${encodeURIComponent(billType)}`;
    if (statDate) url += `&statDate=${statDate}`;
    if (startTime) url += `&startTime=${startTime}`;
    if (endTime) url += `&endTime=${endTime}`;
    if (coin) url += `&coin=${coin}`;
    if (counterpartyUserId !== '' && counterpartyUserId != null) {
      url += `&counterpartyUserId=${counterpartyUserId}`;
    }
    if (bizId) url += `&bizId=${encodeURIComponent(bizId)}`;
    return http.get({ url });
  },
  detailExcel({
    statDate = '',
    startTime = '',
    endTime = '',
    billType = '',
    coin = '',
    counterpartyUserId = '',
    bizId = '',
  } = {}) {
    let url = `/ta/admin/tenant/public-subject/bill-statistic/detail/excel?billType=${encodeURIComponent(billType)}`;
    if (statDate) url += `&statDate=${statDate}`;
    if (startTime) url += `&startTime=${startTime}`;
    if (endTime) url += `&endTime=${endTime}`;
    if (coin) url += `&coin=${coin}`;
    if (counterpartyUserId !== '' && counterpartyUserId != null) {
      url += `&counterpartyUserId=${counterpartyUserId}`;
    }
    if (bizId) url += `&bizId=${encodeURIComponent(bizId)}`;
    return http.get({ url, responseType: 'blob' });
  },
};
